export const wellKnownRoutes = {
  Timeout: 'Timeout',
  NotFound: 'NotFound',
  Config: 'Config',
};
